import React, { Component } from 'react';
import { Row, Col, Card, Container, Form, Button } from 'react-bootstrap';
import { components } from 'react-select'
import * as Cookies from "es-cookie";
import '../_quiz.scss';
import SelectBoxWithDisabledOption from '../../selectdropdown/SelectBoxWithDisabledOption';
import { Link, withRouter } from 'react-router-dom';
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import parse, { domToReact } from 'html-react-parser';
import { Scrollbars } from 'react-custom-scrollbars'
import InfiniteScroll from 'react-infinite-scroll-component';
import { scroller } from "react-scroll";
import QuizModal from '../../quiz_section/QuizModal';
import moment from 'moment';
import MultiSelect from "react-multi-select-component";

const GROUPcreateQuizPaper = gql`
  mutation(
    $params:GroupCustomPaper,
    $time_duration:Int,
    $question_count:[SubjectQuestionCount]  
    ) {
        createQuizPaper(
        params: $params,
        time_duration: $time_duration,
        question_count: $question_count
     ){
         filename
        exam_paper_id
        exam_questions{
            id
            subject
            chapter
            question
            option1
            option2
            option3
            option4
            qtype
            compquestion
            list1type
            list2type
            mat_question
            answer
            inputquestion
            chapter_name
        }
     }
  }
`;

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        width: '3px',
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class CreateQuizSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            qbsearchExamType: "0",
            qbsearchExamTypevalue: "",
            qbsearchsubject: "0",
            qbsearchsubjectvalue: "",
            qbsearchchapter: "0",
            qbsearchchaptervalue: "",
            qbsearchtopic: "0",
            qbsearchtopicvalue: "",
            subjects: [],
            owedqfilterclass: "1",
            getInstituteQuestions: "",
            validateExamType: "",
            validateSubject: "",
            validateChapter: "",
            questionsLoading: "",
            showSpinner: "hide",
            viewType: "6Questions",
            validateQuestionSelected: [],
            checkedVall: false,
            exam_name: "",
            submitError1: "",
            buttonstatus: "",
            startdate: "",
            enddate: "",
            modalShow: false,
            modalShowTwo: false,
            currentStep: 1,
            exam_name: "",
            class: "",
            classvalue: "",
            section: "",
            sectionvalue: "",
            branch: "",
            timeduration: 0,
            subjectOptions: [],
            validationMessage: "",
            validateTopic: "",
            questionSelectedMessage: "",
            examTypeOptions: [],
            qbquestiontypes: [],
            qbquestiontypesvalue: [],
            getSectionsArr: [],
            getChaptersArr: [],
            getTopicsArr: [],
            hasMore: true,
            page: 1
        }
    }

    idFunction(data) {
        let id = parseInt(data + 1);
        return id;
    }
    componentDidMount() {

        // let examsData = this.props.globals.exams.find((a) => a.id == "1");
        //let examsubjectData = examsData.exam_subjects;
        let examsubjectData = this.props.globals.subjects;
        let subjects = [];




        // newcodeend
        for (let i = 0; i <= examsubjectData.length; i++) {
            let idata = examsubjectData[i];
            console.log("idata", idata);
            if (idata != undefined) {
                let subjectData = this.props.globals.subjects.find((a) => a.id == idata.id);
                // console.log("subjectData", subjectData);
                let chapters = subjectData.chapters.map((item) => {
                    console.log("subjectData", subjectData);
                    const topic = item.topics.map((topicData) => {
                        return { ...topicData, checked: false }
                    })

                    return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [], questionbarray: [] }
                })



                const newObject = {
                    id: subjectData.id,
                    subject: subjectData.subject,
                    chapters: chapters,
                    checked: false,
                    subjectactive: "d-flex justify-content-between align-items-center",
                    qcount: idata.no_of_questions,
                    totError: ""

                }
                subjects.push(newObject);


            }

        }
        let examTypeArr = [];
        for (let i = 0; i <= this.props.globals.exams.length; i++) {
            let idata = this.props.globals.exams[i];
            if (idata != undefined) {
                const newObj = {
                    value: idata.id,
                    label: idata.exam,
                }

                examTypeArr.push(newObj);

            }

        }



        this.setState({
            subjects: subjects,
            examTypeOptions: examTypeArr
        });
    }


    getChapters = () => {
        console.log("aravind", this.state.subjects)
        let getArray = [];
        for (let i = 0; i <= this.state.subjects.length; i++) {
            let idata = this.state.subjects[i];
            if (idata != undefined) {
                console.log("aravind", idata.id)
                console.log("aravind", this.state.qbsearchsubject)
                if (idata.id == this.state.qbsearchsubject) {

                    let chData = idata.chapters;
                    chData.map((chmapData) => {
                        const newObj = {
                            value: chmapData.id,
                            label: chmapData.chapter
                        }
                        getArray.push(newObj);
                    })

                }
            }

        }
        this.setState({
            getChaptersArr: getArray
        });

    }

    getTopics = () => {
        let getArray = [];
        for (let i = 0; i <= this.state.subjects.length; i++) {
            let idata = this.state.subjects[i];
            if (idata != undefined) {
                if (idata.id == this.state.qbsearchsubject) {
                    idata.chapters.map((chmapData) => {
                        if (chmapData.id == this.state.qbsearchchapter) {
                            chmapData.topics.map((topicData) => {
                                const newObj = {
                                    value: topicData.id,
                                    label: topicData.topic
                                }
                                getArray.push(newObj);
                            })
                        }

                    })

                }
            }

        }
        console.log("aravind", getArray)
        this.setState({
            getTopicsArr: getArray
        });
    }


    selecthandleInputChange = async (ename, evalue) => {

        console.log("selecthandleInputChange", ename, evalue);
        const name = ename;
        const value = evalue;

        if (name == "qbsearchsubject") {


            let subjectData = this.state.subjects.find((a) => a.id == value);
            this.setState({
                qbsearchsubjectvalue: {
                    value: subjectData.id,
                    label: subjectData.subject
                },
                qbsearchchapter: "",
                qbsearchchaptervalue: "",
                qbsearchtopic: "0",
                qbsearchtopicvalue: "",
            });

            setTimeout(() => {
                this.getChapters();
            }, 800);

        }

        if (name == "qbsearchchapter") {
            let subjectData = this.props.globals.subjects.find((a) => a.id == this.state.qbsearchsubject);
            let chData = subjectData.chapters.find((a) => a.id == value);


            this.setState({
                qbsearchchaptervalue: {
                    value: chData.id,
                    label: chData.chapter
                },
                qbsearchtopic: "0",
                qbsearchtopicvalue: "",
            });

            setTimeout(() => {
                this.getTopics();
            }, 1000);
        }
        if (name == "qbsearchtopic") {
            let subjectData = this.props.globals.subjects.find((a) => a.id == this.state.qbsearchsubject);
            let chData = subjectData.chapters.find((a) => a.id == this.state.qbsearchchapter);
            let topicData = chData.topics.find((a) => a.id == value);

            this.setState({
                qbsearchtopicvalue: {
                    value: topicData.id,
                    label: topicData.topic
                }
            });
        }
        if (name == "class") {
            let classData = this.props.globals.classes.find((a) => a.id == value);
            this.setState({
                classvalue: {
                    value: classData.id,
                    label: classData.class
                }
            });
        }
        if (name == "section") {
            let sectionsData = this.props.globals.globalSections.find((a) => a.id == value);
            this.setState({
                sectionvalue: {
                    value: sectionsData.id,
                    label: sectionsData.section_name
                }
            });

            this.setState({
                branch: sectionsData.branch_id
            });
        }

        if (name == "qbsearchExamType") {

            let examsData = this.props.globals.exams.find((a) => a.id == value);
            this.setState({
                qbsearchExamTypevalue: {
                    value: examsData.id,
                    label: examsData.exam
                }
            });


            let getArray1 = [], sectionsArr = [];
            for (let i = 0; i <= this.props.globals.subjects.length; i++) {
                let idata = this.props.globals.subjects[i];
                if (idata != undefined) {
                    console.log("aravind", value)
                    if (value == 1 || value == 7 || value == 8) {
                        if (idata.id != 4) {
                            const newObj = {
                                value: idata.id,
                                label: idata.subject,
                            }
                            getArray1.push(newObj);
                        }

                    } else if (value == 3 || value == 2 || value == 6) {
                        console.log("aravind", value)
                        if (idata.id == 2 || idata.id == 3 || idata.id == 4) {
                            const newObj = {
                                value: idata.id,
                                label: idata.subject,
                            }
                            getArray1.push(newObj);
                        }

                    } else {
                        const newObj = {
                            value: idata.id,
                            label: idata.subject,
                        }
                        getArray1.push(newObj);
                    }
                }

            }
            for (let i = 0; i <= this.props.globals.globalSections.length; i++) {
                let idata = this.props.globals.globalSections[i];
                if (idata != undefined) {
                    if (value == idata.exam_id) {
                        const newObj = {
                            value: idata.id,
                            label: idata.section_name,
                            branch: idata.branch_id
                        }
                        sectionsArr.push(newObj);
                    }
                }
            }

            this.setState({
                subjectOptions: getArray1,
                getSectionsArr: sectionsArr,
                branch: sectionsArr[0].branch
            });


        }

        this.setState({ [name]: value });

    }

    handleInputChange = (e) => {
        console.log("handleInputChange", e.target.name, e.target.checked)
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });

    }
    handleMultipleSelectInputChange = (e, name) => {
        console.log("handleMultipleSelectInputChange", e, name);
        if (name == "qbquestiontypes") {
            let qbquestiontypes = Array();
            let qbquestiontypesvalue = Array();
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbquestiontypesval = e[i];
                    const newObj = {
                        label: qbquestiontypesval.label,
                        value: qbquestiontypesval.value
                    }
                    qbquestiontypesvalue.push(newObj);
                    qbquestiontypes.push(qbquestiontypesval.value);
                }
                this.setState({
                    qbquestiontypesvalue: qbquestiontypesvalue,
                    qbquestiontypes: qbquestiontypes
                });
            }
        }

    }


    onScrollgetQuestionById = async (e) => {
        this.setState({ validateExamType: "", validateSubject: "", validateChapter: "", validateTopic: "", questionsLoading: "", getInstituteQuestions: "", showSpinner: "hide", validationMessage: "", page: 1, hasMore: true });



        if (this.state.qbsearchExamType == "") {
            this.setState({ validateExamType: "Please Select Exam Type" });
            return;
        }
        else if (this.state.qbsearchsubjectvalue == "") {
            this.setState({ validateSubject: "Please Select Subject" });
            return;
        } else if (this.state.qbsearchchaptervalue == "") {
            this.setState({ validateChapter: "Please Select Chapter" });
            return;
        } else if (this.state.qbsearchtopicvalue == "") {
            this.setState({ validateTopic: "Please Select Topic" });
            return;
        }

        this.setState({ showSpinner: "show" });

        const result = await this.props.client.query({
            query: gql` 
        query(
            $subject:String!,
            $chapter:String!,
            $topic:String!,
            $question_type:String,
            $question_theory:String,
            $complexity: String,
            $institute_id: Int!,
            $page: Int,
            $type: Int, 
            
            ) {
                getInstituteQuestionsWithTopic(
                    subject: $subject,
                    chapter: $chapter,
                    topic: $topic,
                    question_type: $question_type,
                    question_theory: $question_theory,
                    complexity:$complexity,
                    institute_id: $institute_id,
                    page:$page,
                    type: $type
                )
                {
                    id
                    subject
                    question
                    chapter
                    topic
                    complexity
                    question_theory
                    qtype
                    mat_question
                    compquestion
                    list1type
                    list2type
                    subject_name
                    chapter_name
                    topic_name
                    option1
                    option2
                    option3
                    option4
                    answer
                    usageset
            }
        }
    `,
            variables: {

                subject: this.state.qbsearchsubject,
                chapter: this.state.qbsearchchapter,
                topic: this.state.qbsearchtopic,
                question_type: "7",
                question_theory: "0",
                complexity: "0",
                institute_id: parseInt(Cookies.get("institutionid")),
                page: 1,
                type: 1

            },
            fetchPolicy: 'network-only'
        });

        console.log("aaaaa", result);

        if (result.data.getInstituteQuestionsWithTopic != undefined) {
            this.setState({
                showSpinner: "hide",
                getInstituteQuestions: result.data.getInstituteQuestionsWithTopic,
                questionsLoading: result.loading
            });
        }


        let getArray1 = [];
        console.log("aravind", this.state.subjectOptions)
        for (let i = 0; i <= this.state.subjectOptions.length; i++) {
            let idata = this.state.subjectOptions[i];
            if (idata != undefined) {
                let newObj = {};
                if (this.state.qbsearchsubject == idata.value) {
                    newObj = {
                        value: idata.value,
                        label: idata.label,
                    }
                } else {
                    newObj = {
                        value: idata.value,
                        label: idata.label,
                        isDisabled: true
                    }
                }


                getArray1.push(newObj);

            }

        }
        this.setState({
            subjectOptions: getArray1
        });
    }

    onScrollgetQuestions = async (e, dactive) => {
        //let totallenth = this.state.getInstituteQuestions.length;

        console.log("ssssssssssssssssssssssssssss", this.state.getInstituteQuestions.length)
        console.log("hasMorehasMorehasMorehasMorehasMore", this.state.hasMore)
        if (this.state.getInstituteQuestions.length < 9) {
            this.setState({ hasMore: false });
        }
        else {

            let page = parseInt(this.state.page) + 1;
            this.setState({
                page: page
            });
            console.log("variables:", {
                subject: this.state.qbsearchsubject,
                chapter: this.state.qbsearchchapter,
                topic: this.state.qbsearchtopic,
                question_type: "7",
                question_theory: "0",
                complexity: "0",
                institute_id: parseInt(Cookies.get("institutionid")),
                page: parseInt(page),
                type: 1
            });

            const result = await this.props.client.query({
                query: gql` 
        query(
            $subject:String!,
            $chapter:String!,
            $topic:String!,
            $question_type:String,
            $question_theory:String,
            $complexity: String,
            $institute_id: Int!,
            $page: Int,
            $type: Int, 
            
            ) {
                getInstituteQuestionsWithTopic(
                    subject: $subject,
                    chapter: $chapter,
                    topic:$topic,
                    question_type: $question_type,
                    question_theory: $question_theory,
                    complexity:$complexity,
                    institute_id: $institute_id,
                    page:$page,
                    type: $type
                )
                {
                    id
                    subject
                    question
                    chapter
                    topic
                    complexity
                    question_theory
                    qtype
                    mat_question
                    compquestion
                    list1type
                    list2type
                    subject_name
                    chapter_name
                    topic_name
                    option1
                    option2
                    option3
                    option4
                    answer
                    usageset
            }
        }
    `,
                variables: {

                    subject: this.state.qbsearchsubject,
                    chapter: this.state.qbsearchchapter,
                    topic: this.state.qbsearchtopic,
                    question_type: "7",
                    question_theory: "0",
                    complexity: "0",
                    institute_id: parseInt(Cookies.get("institutionid")),
                    page: parseInt(page),
                    type: 1

                },
            })
            console.log("result.data.getInstituteQuestions", result.data.getInstituteQuestionsWithTopic);

            if (result.data.getInstituteQuestionsWithTopic.length == 0) {
                this.setState({ hasMore: false, page: page });
                return;
            }
            else {
                setTimeout(() => {
                    this.setState({
                        page: page,
                        getInstituteQuestions: this.state.getInstituteQuestions.concat(result.data.getInstituteQuestionsWithTopic)
                    });
                }, 2000);
            }


        }

    }

    QuestionFunction = (e, questionsdata, type) => {
        this.setState({ questionSelectedMessage: "" });

        let subjectArray = [];
        let QuestionSelectedLength = 0;
        if (this.state.viewType == "6Questions") {
            QuestionSelectedLength = 5
        } else {
            QuestionSelectedLength = 14
        }
        if (type == "qbank") {
            if (e?.target?.checked == true) {

                if (this.state.validateQuestionSelected.length > QuestionSelectedLength) {
                    scroller.scrollTo("your_css_class_here", {
                        duration: 800,
                        delay: 0,
                        smooth: "easeInOutQuart",
                    });
                    this.setState({ checked: !this.state.checkedVall, validationMessage: "Maximum Questions Reached" });
                    return;
                }

                this.state.validateQuestionSelected.push(questionsdata);
            } else {
                for (var i in this.state.validateQuestionSelected) {
                    if (this.state.validateQuestionSelected[i].id == questionsdata.id) {
                        this.state.validateQuestionSelected.splice(i, 1);
                        this.setState({ validateQuestionSelected: this.state.validateQuestionSelected });
                    }

                }
            }

            subjectArray = this.state.subjects.map((subjectData) => {
                if (subjectData.id == this.state.qbsearchsubject) {
                    const chData = subjectData.chapters.map((chmapData) => {
                        if (chmapData.id == this.state.qbsearchchapter) {
                            if (e?.target?.checked == true) {
                                let array = chmapData.questionbarray;
                                array.push({ ...questionsdata });
                                return { ...chmapData, questionbarray: array }

                            }
                            else {
                                const questionbarray = chmapData.questionbarray.filter((a) => a.id != questionsdata.id);
                                //questionbarray.push(questionsdata);
                                return { ...chmapData, questionbarray: questionbarray }
                            }
                        }
                        return { ...chmapData }

                    })
                    return { ...subjectData, chapters: chData }
                }
                return { ...subjectData }
            });
        }


        this.setState({ subjects: subjectArray });

    }


    clearValidations = () => {

        this.setState({
            validateQuestionSelected: [],
            qbsearchchapter: "",
            qbsearchchaptervalue: "",
            qbsearchsubjectvalue: "",
            qbsearchtopic: "0",
            qbsearchtopicvalue: "",
            owedqfilterclass: "1",
            getInstituteQuestions: "",
            validateExamType: "",
            validateSubject: "",
            validateChapter: "",
            questionsLoading: "",
            showSpinner: "hide",
            validateTopic: "",
            validationMessage: "",
            getChaptersArr: [],
            getTopicsArr: [],
            subjects: [],
            subjectOptions: [],
            hasMore: true,
            page: 1

        });


        let examsubjectData = this.props.globals.subjects;
        let subjects = [];

        // newcodeend
        for (let i = 0; i <= examsubjectData.length; i++) {
            let idata = examsubjectData[i];
            console.log("idata", idata);
            if (idata != undefined) {
                let subjectData = this.props.globals.subjects.find((a) => a.id == idata.id);
                // console.log("subjectData", subjectData);
                let chapters = subjectData.chapters.map((item) => {
                    console.log("subjectData", subjectData);
                    const topic = item.topics.map((topicData) => {
                        return { ...topicData, checked: false }
                    })

                    return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [], questionbarray: [] }
                })



                const newObject = {
                    id: subjectData.id,
                    subject: subjectData.subject,
                    chapters: chapters,
                    checked: false,
                    subjectactive: "d-flex justify-content-between align-items-center",
                    qcount: idata.no_of_questions,
                    totError: ""

                }
                subjects.push(newObject);


            }

        }


        this.setState({
            subjects: subjects,
        });


        let getArray1 = [];
        for (let i = 0; i <= this.state.subjectOptions.length; i++) {
            let idata = this.state.subjectOptions[i];
            if (idata != undefined) {

                const newObj = {
                    value: idata.value,
                    label: idata.label,
                }


                getArray1.push(newObj);

            }

        }
        this.setState({
            subjectOptions: getArray1
        });
    }

    handleSelect(val) {


        this.setState({
            viewType: val,
            validateQuestionSelected: [],
            qbsearchExamType: "0",
            qbsearchExamTypevalue: "",
            qbsearchsubject: "0",
            qbsearchsubjectvalue: "",
            qbsearchchapter: "0",
            qbsearchchaptervalue: "",
            qbsearchtopic: "0",
            qbsearchtopicvalue: "",
            owedqfilterclass: "1",
            getInstituteQuestions: "",
            validateExamType: "",
            validateSubject: "",
            validateChapter: "",
            questionsLoading: "",
            showSpinner: "hide",
            validateTopic: "",
            validationMessage: "",
            subjectOptions: [],
            getChaptersArr: [],
            getTopicsArr: [],
            hasMore: true,
            page: 1
        });
    }

    popupModalQuiz = (e) => {
        let QuestionSelectedLength = 0;
        if (this.state.viewType == "6Questions") {
            QuestionSelectedLength = 5
        } else {
            QuestionSelectedLength = 14
        }

        if (this.state.validateQuestionSelected.length < QuestionSelectedLength) {
            let remainingQusSel = 0;
            remainingQusSel = (QuestionSelectedLength - this.state.validateQuestionSelected.length) + 1;
            if (this.state.viewType == "6Questions") {
                this.setState({ questionSelectedMessage: "Please Check Remaining " + remainingQusSel + " Questions " });
            } else {
                this.setState({ questionSelectedMessage: "Please Check Remaining " + remainingQusSel + " Questions " });
            }

            return;
        } else {
            this.setState({ modalShow: true, submitError1: "" })
        }

    }
    sheduleFunction = (e) => {
        this.setState({ isonline: "1" });
        this.setState({
            submitError: "",
            buttonstatus: "shedule"
        });
    }

    datefunction = (moment, name) => {
        console.log("datefunction", moment._d, name);
        let date = String(moment._d);
        var res = date.substr(4, 20);
        console.log("res", res);
        this.setState({ startdate: res });

        this.setState({
            submitError1: ""
        });
    }
    datefunctionend = (moment, name) => {
        console.log("datefunction", moment._d, name);
        let date = String(moment._d);
        var res = date.substr(4, 20);
        console.log("res", res);
        this.setState({ enddate: res });

        this.setState({
            submitError1: ""
        });
    }

    handleFormSubmit = (e, type) => {


        e.preventDefault();

        this.setState({
            spinnerStatus: "1"
        });
        setTimeout(() => {
            console.log("Form submitted", this.state);
            console.log("aravind", this.props)
            let stateSyllabus = this.state.subjects;
            let syllabusArray = [];
            let qbankQuestion = [];
            let ownedQuestion = [];
            let selectedSubjectId = [];
            let topicArray = [];
            let sectionsArr = [];
            let is_draft = 0;
            for (let i = 0; i < stateSyllabus.length; i++) {

                let idata = stateSyllabus[i];
                console.log("idata", idata);
                let totalchapters = idata.chapters;
                for (let x = 0; x < totalchapters.length; x++) {
                    let tdata = totalchapters[x];

                    if (tdata.questionbarray.length > 0) {
                        tdata.questionbarray.map((questionbarraymapData) => {
                            const newquestionId = questionbarraymapData;
                            qbankQuestion.push(parseInt(newquestionId.id));
                        })

                    }

                    let totaltopics = tdata.topics;

                    for (let y = 0; y < totaltopics.length; y++) {
                        let ttdata = totaltopics[y];
                        console.log("ttdata", ttdata);
                        if (ttdata.checked == true) {
                            let newtopic = ttdata.id;
                            console.log("newtopic", newtopic);
                            topicArray.push(newtopic);

                        }
                    }

                }

                console.log("topicArray", topicArray);
                const newSyllabus = {
                    subject_id: parseInt(idata.id),
                    chapters: [],
                    topics: topicArray
                }
                syllabusArray.push(newSyllabus);



                if (this.state.qbsearchsubject == idata.id) {
                    selectedSubjectId.push(parseInt(idata.id));

                }

            }


            for (let i = 0; i < this.state.qbquestiontypes.length; i++) {
                sectionsArr.push(parseInt(this.state.qbquestiontypes[i]));
            }
            let newArray = syllabusArray.filter(item =>
                item.topics.length > 0
            )

            let startdate = "";
            let enddate = "";
            console.log("ssss", startdate, enddate);

            if (this.state.startdate != "") {
                is_draft = 0;
                if (this.state.startdate == "") {

                    startdate = moment().unix();
                    //moment().format("DD-MM-YYYY @ HH:mm:ss");
                }
                else {
                    startdate = moment(this.state.startdate, "MMM DD YYYY HH:mm:ss").unix();
                }

            } else {
                is_draft = 1;
                startdate = moment().unix();
            }

            if (Cookies.get("institutionid") == 19) {
                enddate = moment(this.state.enddate, "MMM DD YYYY HH:mm:ss").unix();
            } else {
                enddate = "";
            }

            if (this.state.viewType == "6Questions") {
                this.state.timeduration = 15
            } else {
                this.state.timeduration = 30
            }

            let creategeneralpaper = "";
            creategeneralpaper = {
                exam_type: parseInt(this.state.qbsearchExamType),
                exam_name: this.state.exam_name,
                class_id: parseInt(this.state.class),
                branch: Cookies.get("institutionid") != 19 ? this.state.branch.toString() : "0",
                section: sectionsArr.toString(),
                start_time: startdate.toString(),
                end_time: enddate.toString(),
                institution_id: parseInt(Cookies.get("institutionid")),
                username: Cookies.get("username"),
                questionbank_questions: qbankQuestion.toString(),
                institution_questions: ownedQuestion.toString(),
                no_of_sets: 1,
                question_type: selectedSubjectId.toString(),
                is_draft: is_draft,
                subject_id: parseInt(selectedSubjectId)
            }
            console.log("paper", creategeneralpaper);
            const question_count = this.state.subjects.map((a) => {
                return {
                    subject_id: parseInt(a.id),
                    question_count: parseInt(this.state.validateQuestionSelected.length)
                }
            });
            console.log('creategeneralpaper', creategeneralpaper,
                parseInt(this.state.timeduration),
                question_count);

            this.creategroupgeneralpaperfun(
                creategeneralpaper,
                parseInt(this.state.timeduration),
                question_count
            ).catch(error => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError1: error.graphQLErrors.map(x => x.message), spinnerStatus: ""
                });
                console.error("ERR =>", error.graphQLErrors.map(x => x.message));
            });

        }, 1000);
    };

    creategroupgeneralpaperfun = async (
        params,
        time_duration,
        question_count
    ) => {
        await this.props.creategroupgeneralpaperfun({
            variables: {
                params,
                time_duration,
                question_count
            },
            update: (store, { data }) => {
                console.log("createGeneralPaperdata", data);
                if (data.createQuizPaper) {

                    this.setState({
                        currentStep: 5,
                        submitError1: "",
                        filename: data.createQuizPaper.filename,
                    });


                    setTimeout(() => {
                        window.location.reload(true);
                    }, 2000);


                }
            }
        });
    };


    getSelectedSubject = () => {
        let subjectName = '';
        if (this.state.qbsearchsubject == "1") {
            subjectName = "Botany"
        } else if (this.state.qbsearchsubject == "2") {
            subjectName = "Physics"
        } else if (this.state.qbsearchsubject == "3") {
            subjectName = "Chemistry"
        } else if (this.state.qbsearchsubject == "4") {
            subjectName = "Mathematics"
        } else if (this.state.qbsearchsubject == "5") {
            subjectName = "Zoology"
        }

        return subjectName;
    }


    quentionSearchhandleChange = (e) => {
        this.setState({
            qbsearchsubject: e.target.value
        });

    }

    render() {
        console.log("chapter", this.state.qbsearchchapter)
        console.log("aravind", this.state)

        let finddata = [];
        let newData1 = [];
        let latestData = [];


        if (this.state.getInstituteQuestions != "") {
            this.state.getInstituteQuestions.map((item) => {
                this.state.subjects.map((item1) => {
                    if (parseInt(item1.id) == parseInt(item.subject)) {
                        item1.chapters.map((item3) => {

                            const arr = item.chapter;
                            console.log("sssss", arr)
                            if (arr.includes(item3.id.toString())) {
                                if (item3.questionbarray.length > 0) {
                                    finddata = item3.questionbarray
                                    console.log("find", finddata);
                                }
                            }

                        })
                    }
                })
            });

            console.log("finddatafinddatafinddatafinddata", finddata)


            if (finddata.length > 0) {
                newData1 = this.state.getInstituteQuestions.map((item) => {

                    if (finddata.length > 0) {
                        console.log("item", item)


                        if (finddata.find((a) => a.id == item.id)) {
                            return { ...item, checked: true }
                        }
                        else {
                            return { ...item, checked: false }
                        }
                    }


                })
            }

            if (newData1.length > 0) {
                latestData = newData1.filter((a) => a.id.includes(this.state.qbsearchsubject));
            } else {
                //latestData = this.state.getInstituteQuestions;
                latestData = this.state.getInstituteQuestions.filter((a) => a.id.includes(this.state.qbsearchsubject));
            }
            console.log("this.state.generalCheckedgeneralChecked", this.state);




        }


        return (
            <>
                <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '18px 22px', borderBottom: '1px solid #f1f5f9' }}>
                    <div style={{ background: '#f5f3ff', color: '#7c3aed', borderRadius: 10, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>
                        <i className="fal fa-plus-circle" />
                    </div>
                    <div>
                        <div style={{ fontWeight: 800, fontSize: 16, color: '#1f2937', letterSpacing: '-0.01em' }}>Create Quiz</div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>Pick a duration, select topics, and publish to your sections</div>
                    </div>
                </div>
                <div style={{ padding: '18px 22px' }}>
                <Row className='your_css_class_here'>
                    <Col sm={12}>
                        <ul className='list-inline question_sel_cls'>

                            <li className={this.state.viewType == "6Questions" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("6Questions")}>15 Mins, 6 Questions</li>
                            <li className={this.state.viewType == "15Questions" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("15Questions")}>30 Mins, 15 Questions</li>
                        </ul>
                    </Col>
                    <Col>
                        <Card as={Card.Body} className="">
                            <Form>
                                <Row>

                                </Row>
                                <Row>
                                    <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="slectSubject">
                                        <Form.Label className="text-uppercase font-weight-bold">Exam Type <span className='errorCls'>{this.state.validateExamType}</span></Form.Label>
                                        <SelectBoxWithDisabledOption
                                            stateData={this.state.qbsearchExamTypevalue}
                                            handleChange={this.selecthandleInputChange}
                                            name="qbsearchExamType"
                                            options={this.state.examTypeOptions}
                                            placeholderName={'Exam Type'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="slectSubject">
                                        <Form.Label className="text-uppercase font-weight-bold">Subject <span className='errorCls'>{this.state.validateSubject}</span></Form.Label>
                                        <SelectBoxWithDisabledOption
                                            stateData={this.state.qbsearchsubjectvalue}
                                            handleChange={this.selecthandleInputChange}
                                            name="qbsearchsubject"
                                            options={this.state.subjectOptions}
                                            placeholderName={'Subject'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                            isOptionDisabled={option => option.isDisabled}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="SelectChapters">
                                        <Form.Label className="text-uppercase font-weight-bold">Chapter <span className='errorCls'>{this.state.validateChapter}</span></Form.Label>
                                        <SelectBoxWithDisabledOption
                                            stateData={this.state.qbsearchchaptervalue}
                                            handleChange={this.selecthandleInputChange}
                                            name="qbsearchchapter"
                                            options={this.state.getChaptersArr}
                                            placeholderName={'Chapters'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="SelectTopics">
                                        <Form.Label className="text-uppercase font-weight-bold">Topic <span className='errorCls'>{this.state.validateTopic}</span></Form.Label>
                                        <SelectBoxWithDisabledOption
                                            stateData={this.state.qbsearchtopicvalue}
                                            handleChange={this.selecthandleInputChange}
                                            name="qbsearchtopic"
                                            options={this.state.getTopicsArr}
                                            placeholderName={'Topics'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />

                                        {/* <MultiSelect
                                    
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Question types are selected.",
                                        "selectSomeItems": topiclabelledBy
                                    }
                                    }
                                    disableSearch={topicdisableSearch}
                                    hasSelectAll={topicselectall}
                                    options={getTopicArr}
                                    value=""
                                    labelledBy={"Select"}
                                    onChange={(e) => this.props.handleMultipleSelectInputChange(e, "qbquestiontypes")}
                                    height="250px"
                                />*/}
                                    </Form.Group>

                                </Row>
                                <Row>
                                    <Col sm={6}>
                                        {
                                            this.state.getInstituteQuestions.length > 0 ?
                                                (
                                                    <p className='mt-2'>Note : If You Change Subject Please Click <b>CLEAR OPTION</b> - <span className="clearCls" onClick={(e) => this.clearValidations(e)}>CLEAR</span></p>
                                                )
                                                :
                                                ("")
                                        }
                                    </Col>
                                    <Col sm={6}>
                                        <Button type="button" className="btn btn-light-blue float-right mt-2" onClick={(e) => this.onScrollgetQuestionById(e)}>Get Questions</Button>
                                    </Col>
                                </Row>



                            </Form>

                            {
                                this.state.getInstituteQuestions == "" ?
                                    (
                                        <Row>
                                            <Col sm={12} className={this.state.showSpinner == "show" ? "showSpinnerCls text-center" : "hideSpinnerCls text-center"}>
                                                <div class="spinner-border text-primary text-center loading-img-center"></div>
                                            </Col>
                                        </Row>
                                    )
                                    :
                                    ("")
                            }

                            {this.state.getInstituteQuestions.length > 0 ? (
                                <div>
                                    <Row className="mt-5">
                                        <Col sm={12} >
                                            <h5>
                                                {

                                                    this.state.viewType == "6Questions" ?
                                                        (<><span>{this.getSelectedSubject()}</span> : Questions Selected - {this.state.validateQuestionSelected.length}/6 <span className='errorCls1'>{this.state.validationMessage}</span></>)
                                                        :
                                                        (<><span>{this.getSelectedSubject()}</span> : Questions Selected - {this.state.validateQuestionSelected.length}/15 <span className='errorCls1'>{this.state.validationMessage}</span></>)


                                                }

                                                {

                                                    this.state.viewType == "6Questions" ?
                                                        (
                                                            <>
                                                                {
                                                                    this.state.validateQuestionSelected.length >= 6 ?
                                                                        (
                                                                            <span><Button type="button" className="btn btn-light-blue float-right" onClick={(e) => this.popupModalQuiz()}>Generate Quiz</Button></span>
                                                                        )
                                                                        :
                                                                        ("")
                                                                }
                                                            </>

                                                        )
                                                        :
                                                        (
                                                            <>
                                                                {
                                                                    this.state.validateQuestionSelected.length >= 15 ?
                                                                        (
                                                                            <span><Button type="button" className="btn btn-light-blue float-right" onClick={(e) => this.popupModalQuiz()}>Generate Quiz</Button></span>
                                                                        )
                                                                        :
                                                                        ("")
                                                                }
                                                            </>

                                                        )


                                                }


                                            </h5>
                                            <h6 className='errorCls1'>{this.state.questionSelectedMessage}</h6>


                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12}>
                                            <Card as={Card.Body}>
                                                {/* <Row>
                                            <Col sm={12}>
                                                <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="quentionSearch" className='float-right'>
                                                    <Form.Control
                                                        type="text"
                                                        name="quesionsearch"
                                                        value={this.state.quesionsearch}
                                                        onChange={this.quentionSearchhandleChange}
                                                        placeholder="Question Search"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row> */}

                                                <Scrollbars style={{ height: 800 }}
                                                    {...this.props}
                                                    renderThumbVertical={renderThumb}
                                                    autoHide
                                                    autoHideTimeout={800}
                                                    autoHideDuration={200}>
                                                    {this.state.getInstituteQuestions.length > 0 ? (
                                                        <InfiniteScroll
                                                            dataLength={this.state.getInstituteQuestions.length}
                                                            next={(e) => this.onScrollgetQuestions(e)}
                                                            hasMore={this.state.hasMore}
                                                            loader={
                                                                <p style={{ textAlign: "center", overflow: "hidden !important" }}>
                                                                    <b>Loading...</b>
                                                                </p>}
                                                            endMessage={
                                                                <p style={{ textAlign: "center", overflow: "hidden !important" }}>
                                                                    <b>Yay! You have seen it all</b>
                                                                </p>
                                                            }
                                                        >
                                                            {latestData.map((questionsData, index) => {
                                                                return (
                                                                    <Card as={Card.Body} className="bg-light mt-2">
                                                                        <Form.Check type="checkbox" id={"checkbox_4031" + index} custom>
                                                                            {
                                                                                questionsData.checked == true ?
                                                                                    (<Form.Check.Input type="checkbox" checked={questionsData.checked} onChange={(e) => { this.QuestionFunction(e, questionsData, "qbank"); }} />)
                                                                                    :
                                                                                    (<Form.Check.Input type="checkbox" checked={this.state.checkedVall} onChange={(e) => { this.QuestionFunction(e, questionsData, "qbank"); }} />)
                                                                            }

                                                                            <Form.Check.Label htmlFor={"checkbox_4031" + index}>
                                                                                <span>{this.idFunction(index)} .</span>
                                                                                {parse(questionsData.question)}
                                                                                {" QID- " + questionsData.id}
                                                                            </Form.Check.Label>
                                                                        </Form.Check>
                                                                        <hr className="my-3" />
                                                                        <Row>
                                                                            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span>A.</span>
                                                                                    <div className="ml-2">{parse(questionsData.option1)}</div>
                                                                                </div>
                                                                            </Col>
                                                                            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span>B.</span>
                                                                                    <div className="ml-2">{parse(questionsData.option2)}</div>
                                                                                </div>
                                                                            </Col>
                                                                            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span>C.</span>
                                                                                    <div className="ml-2">{parse(questionsData.option3)}</div>
                                                                                </div>
                                                                            </Col>
                                                                            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span>D.</span>
                                                                                    <div className="ml-2">{parse(questionsData.option4)}</div>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span className="font-weight-bold">Currect Answer:</span>
                                                                                    <div className="font-weight-bold ml-2">{questionsData.answer}</div>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>

                                                                    </Card>
                                                                )
                                                            })}
                                                        </InfiniteScroll>) : (
                                                        <React.Fragment>
                                                            {latestData.map((questionsData, index) => {
                                                                return (
                                                                    <Card as={Card.Body} className="bg-light mt-2">
                                                                        <Form.Check type="checkbox" id={"checkbox_4031" + index} custom>
                                                                            {
                                                                                questionsData.checked == true ?
                                                                                    (<Form.Check.Input type="checkbox" checked={questionsData.checked} onChange={(e) => { this.QuestionFunction(e, questionsData, "qbank"); }} />)
                                                                                    :
                                                                                    (<Form.Check.Input type="checkbox" checked={this.state.checkedVall} onChange={(e) => { this.QuestionFunction(e, questionsData, "qbank"); }} />)
                                                                            }

                                                                            <Form.Check.Label htmlFor={"checkbox_4031" + index}>
                                                                                <span>{this.idFunction(index)} .</span>
                                                                                {parse(questionsData.question)}
                                                                                {" QID- " + questionsData.id}
                                                                            </Form.Check.Label>
                                                                        </Form.Check>
                                                                        <hr className="my-3" />
                                                                        <Row>
                                                                            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span>A.</span>
                                                                                    <div className="ml-2">{parse(questionsData.option1)}</div>
                                                                                </div>
                                                                            </Col>
                                                                            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span>B.</span>
                                                                                    <div className="ml-2">{parse(questionsData.option2)}</div>
                                                                                </div>
                                                                            </Col>
                                                                            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span>C.</span>
                                                                                    <div className="ml-2">{parse(questionsData.option3)}</div>
                                                                                </div>
                                                                            </Col>
                                                                            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span>D.</span>
                                                                                    <div className="ml-2">{parse(questionsData.option4)}</div>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span className="font-weight-bold">Currect Answer:</span>
                                                                                    <div className="font-weight-bold ml-2">{questionsData.answer}</div>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>

                                                                    </Card>
                                                                )
                                                            })}

                                                            {this.state.getInstituteQuestions.length == 0 ? (<p style={{ textAlign: "center" }}>
                                                                <b>No data available </b>
                                                            </p>) : (<p style={{ textAlign: "center" }}>
                                                                <b>Yay! You have seen it all</b>
                                                            </p>)}
                                                        </React.Fragment>
                                                    )}
                                                </Scrollbars>
                                            </Card>
                                        </Col>
                                    </Row>


                                </div>

                            ) : ("")}


                        </Card>

                    </Col>

                </Row>
                <Row>
                    <Col sm={12}>
                        <QuizModal
                            stateData={this.state}
                            parentpdatefunction={this.datefunction}
                            parentpdatefunctionend={this.datefunctionend}
                            ParentsheduleFunction={this.sheduleFunction}
                            ParenthandleFormSubmit={this.handleFormSubmit}
                            show={this.state.modalShow}
                            showothermodal={() => this.setState({ modalShowTwo: true })}
                            onHide={() => this.setState({ modalShow: false, submitError1: "" })}
                            globals={this.props.globals}
                            getSections={this.state.getSectionsArr}
                            phandleInputChange={this.handleInputChange}
                            pselecthandleInputChange={this.selecthandleInputChange}
                            handleMultipleSelectInputChange={this.handleMultipleSelectInputChange}
                        />
                    </Col>

                </Row>
                </div>
                </div>
            </>
        )
    }
}


export default withRouter(withApollo(
    compose(
        graphql(GROUPcreateQuizPaper, {
            name: "creategroupgeneralpaperfun"
        }),


    )
        (CreateQuizSection)));    
